module.exports = __webpack_public_path__ + "static/media/WU_CONTENT_user_avatar.8c2d8d76.svg";